/* eslint-disable aveny/no-color-rule */

import Box from '@mui/material/Box';
import { IRapportEditBoxControl } from './RapportMallTypes';
import {
  AVENY_REPORT_EDITBOX_HEIGHT,
  SELECTED_SHADOW,
  getPositionStyle,
} from './RapportMallUtils';
import { getTypographyStyle } from './RapportTypography';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { RapportKontrollEditPosition } from './RapportKontrollEditPosition';
import { RapportKontrollHeader } from './RapportKontrollHeader';
import { RapporteditorTextField } from '../Rapporteditor/RapporteditorTextField';

export interface IProps {
  ctrl: IRapportEditBoxControl;
  controlPath: number[];
  sx?: any;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onSelect?: (path: number[]) => void;
  onUpdate?: (updatedControl: IRapportEditBoxControl) => void;
  selected?: boolean;
  maxWidth: number;
}

export const RapportEditBox: React.FC<IProps> = props => {
  const { ctrl, sx, onMouseEnter, onMouseLeave, selected, maxWidth } = props;
  const handleSelect = (e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    if (props.onSelect) {
      props.onSelect(props.controlPath);
    }
  };
  return (
    <Box
      sx={{
        background: '#e9eeff',
        border: 'none',
        boxShadow: selected ? SELECTED_SHADOW : undefined,
        boxSizing: 'border-box',
        resize: 'none',
        overflow: 'hidden',
        outline: 'none',
        ...getTypographyStyle(
          ctrl.Size,
          ctrl.Height ?? AVENY_REPORT_EDITBOX_HEIGHT,
          undefined,
          ctrl.Multiline
        ),
        ...getPositionStyle(
          ctrl,
          props.controlPath.length > 1,
          maxWidth,
          AVENY_REPORT_EDITBOX_HEIGHT
        ),
        ...sx,
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={handleSelect}
      component={ctrl.Multiline ? 'textarea' : 'input'}
      value={ctrl.Text ?? ''}
      onChange={(
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      ) => {
        if (props.onUpdate) {
          props.onUpdate({ ...ctrl, Text: e.target.value });
        }
      }}
      type="text"
      data-control-path={props.controlPath.join('-')}
    />
  );
};

export interface IRapportEditBoxEditProps {
  value: IRapportEditBoxControl;
  onChange: (ctrl: IRapportEditBoxControl) => void;
}

export const RapportEditBoxEdit: React.FC<IRapportEditBoxEditProps> = props => (
  <Box sx={{ mt: 2 }}>
    <Box sx={{ mb: 3 }}>
      <RapportKontrollHeader value={props.value} />
      <TextField
        label="Namn"
        value={props.value.Name}
        onChange={e => props.onChange({ ...props.value, Name: e.target.value })}
        fullWidth
        size="small"
        sx={{ mb: 2 }}
      />
      <RapporteditorTextField
        label="Text"
        field="Text"
        value={props.value}
        onChange={props.onChange}
        allowModelSelect
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={!!props.value.Multiline}
            onChange={e =>
              props.onChange({ ...props.value, Multiline: e.target.checked })
            }
          />
        }
        label="Flera rader"
        sx={{ mb: 2 }}
      />
      <TextField
        label="Storlek"
        value={props.value.Size ?? ''}
        inputProps={{ maxLength: 4, pattern: '\\d*' }}
        onChange={e =>
          props.onChange({
            ...props.value,
            Size: e.target.value === '' ? undefined : Number(e.target.value),
          })
        }
        fullWidth
        size="small"
        sx={{ mb: 2 }}
      />
    </Box>
    <RapportKontrollEditPosition
      value={props.value}
      onChange={props.onChange}
    />
  </Box>
);
